<template>
  <!-- eslint-disable vue/no-v-html -->
  <div 
    v-html="sanitizedHtml"
  />
  <!-- eslint-enable vue/no-v-html-->
</template>

<script>
import DOMPurify from "dompurify"

export default {
  name: 'ClientHomePageChatMessageMarkdown',
  props: {
    html: {
      type: String,
      required: true,
    },
  },
  computed: {
    sanitizedHtml() {
      return DOMPurify.sanitize(this.html, {
        FORBID_ATTR: ["onclick", "onload", "onerror"],
      })
    },
  },
}
</script>

<style scoped>
:deep(.cr-markdown-table__wrapper) {
  margin-top: var(--space-5);
  margin-bottom: var(--space-5);
  overflow-anchor: none;
  overflow-x: auto;
}

:deep(.cr-markdown-table) {
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: var(--cr-br-large, 0.375rem);
  border: 1px solid var(--pepper-200, #E8E8E8);
  background: #FFF;
  width: max-content;
  overflow: hidden;
}

:deep(.cr-markdown-table__row) {
  display: table-row;
}

:deep(.cr-markdown-table__row:nth-child(even)) {
  background: var(--Pepper-50, #FAFAFA);

}

:deep(.cr-markdown-table__cell) {
  display: table-cell;
  padding: 0.75rem;
  border-bottom: 1px solid var(--pepper-200, #E8E8E8);
  border-right: 1px solid var(--pepper-200, #E8E8E8);
}

:deep(th.cr-markdown-table__call) {
  border-bottom: 1px solid var(--pepper-200, #E8E8E8);
  border-right: 1px solid var(--pepper-200, #E8E8E8);
  text-wrap: none;
  white-space: nowrap;
}

:deep(.cr-markdown-table__row > :last-child) {
  border-right: none;
}

:deep(.cr-markdown-table__row:last-child > .cr-markdown-table__cell) {
  border-bottom: none;
}

:deep(pre.code-block) {
  background-color: var(--pepper-50);
  border-radius: var(--cr-br-large, 0.375rem);;
  margin: 0.5rem;
  padding: 0.75rem;
  overflow-x: auto;
  border: 1px solid var(--pepper-200);
}

:deep(pre.code-block code) {
  background: transparent;
  border: none;
  padding: 0;
  font-size: inherit;
  color: inherit;
}

:deep(blockquote) {
  background: var(--pepper-50);
  border-left: 8px solid var(--pepper-200);
  margin: .75rem 0.5rem;
  padding: 0.5em 10px;
  font-style: italic;
  quotes: "\201C""\201D""\2018""\2019";
}

:deep(blockquote:before) {
  color: var(--pepper-400);
  content: open-quote;
  font-size: 4rem;
  line-height: 0.1em;
  margin-right: 0.25rem;
  vertical-align: -0.4em;
}
:deep(blockquote p) {
  display: inline;
}

</style>

